goog.provide("shadow.js.shim.module$$mui$material$ListItemText$default");
shadow.js.shim.module$$mui$material$ListItemText$default = shadow.js.require(462, {})["default"];
